import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloLink } from "apollo-link";
import { BatchHttpLink } from "apollo-link-batch-http";

import { compose } from "@insightfulscience/shared-utils/fn";
import { publicConfig } from "../config";
import { Token } from "../persistent-storage";
import nextSignleton from "../utils/nextSignleton";
import { resolvers, typeDefs } from "../graphql-local";
import requestLink from "./request-link";
import dataIdFromObject from "../graphql/data-id";
import gtmEventsLink from "./gtm-events-link";
import apolloRecoveryLink from "../utils/apolloRecoveryLink";
import { recoverNotAuthorized, whenNotAuthorized } from "./recoverNotAuthorized";

const addAuthHeader = token => opertation => {
	const authToken = token.get();

	if (!authToken) return;

	const context = opertation.getContext();

	opertation.setContext({
		...context,
		headers: {
			...context.headers,
			Authorization: `Bearer ${authToken}`,
		},
	});
};

const createRequestHandler = compose(addAuthHeader, Token);

const defaultOptions = {
	watchQuery: {
		fetchPolicy: "cache-and-network",
		errorPolicy: "all",
	},
	query: {
		fetchPolicy: "network-only",
		errorPolicy: "none",
	},
};

const apolloClient = nextSignleton(globalContext => {
	const cache = new InMemoryCache({ dataIdFromObject }).restore(globalContext.preloadedState);

	const requestHandler = createRequestHandler(globalContext);

	const link = ApolloLink.from([
		gtmEventsLink,

		requestLink(requestHandler),
		apolloRecoveryLink(
			whenNotAuthorized, // what should recover
			recoverNotAuthorized(globalContext, requestHandler), // how to recover
		),

		new BatchHttpLink({
			uri: publicConfig.GRAPHQL_URI,
			fetch: global.fetch,
		}),
	]);

	const client = new ApolloClient({
		link,
		cache,
		resolvers,
		typeDefs,
		ssrForceFetchDelay: true, // makes getDataFromTree waiting for query resolution
		defaultOptions,
	});

	client.defaultOptions = defaultOptions;

	return client;
});

export default apolloClient;
